import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../models/Entities/Contracts/ContractAddendum';
import { ContractStage } from '../../../models/Entities/Contracts/ContractStage';

export default function ContractAddendumsReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  switch (a.type) {
    case 'CONTRACT_ADDENDUM_FORM_RESET_STATE': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract && a.addendumId) {
        CurrentContract = {
          ...CurrentContract,
          addendums: (CurrentContract.addendums || []).map((item: ContractAddendum) => {
            if (item.id !== a.addendumId) {
              return item;
            }

            return {
              ...item,
              isUpdating: false,
              isUpdatedSuccessfully: undefined,
              FailUpdating: false,
              ErrorUpdating: undefined,
              failOnUpdating: false,
              error: undefined
            } as ContractAddendum;
          })
        };
      }

      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: undefined,
        failOnAddingNewOne: false,
        error: undefined,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_ADDENDUMS_GETBYCONTRACTID_REQUEST': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          isGettingContractAddendums: true,
          isGettingContractAddendumsSuccess: false,
          FailGettingContractAddendums: false,
          ErrorGettingContractAddendums: undefined
        };
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== a.contractId), CurrentContract] : currentState.list,
        error: undefined
      };
    }
    case 'CONTRACT_ADDENDUMS_GETBYCONTRACTID_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        if (CurrentContract.addendums?.length) {
          CurrentContract.addendums = (a.addendums || []).map((addendum: ContractAddendum) => {
            const existing = (CurrentContract!.addendums || []).find((item: ContractAddendum) => item.id === addendum.id);
            if (existing) {
              return {
                ...addendum,
                stages: existing.stages,
                cycles: existing.cycles,
                concepts: existing.concepts,
                branches: existing.branches
              } as ContractAddendum;
            }
            return addendum;
          });
        } else {
          CurrentContract.addendums = a.addendums;
        }
        CurrentContract = {
          ...CurrentContract,
          isGettingContractAddendums: false,
          isGettingContractAddendumsSuccess: true,
          FailGettingContractAddendums: false,
          ErrorGettingContractAddendums: undefined
        };
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
        error: undefined
      };
    }
    case 'CONTRACT_ADDENDUMS_GETBYCONTRACTID_FAILURE': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          isGettingContractAddendums: false,
          isGettingContractAddendumsSuccess: false,
          FailGettingContractAddendums: true,
          ErrorGettingContractAddendums: a.error
        };
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== a.contractId), CurrentContract] : currentState.list,
        error: a.error
      };
    }
    case 'CONTRACT_ADDENDUM_GETBYID_REQUEST': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isUpdating: true,
            isUpdatedSuccessfully: false,
            failOnUpdating: false,
            error: undefined
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
        CurrentContract = {
          ...CurrentContract,
          isUpdating: true,
          isGettingContractAddendumsSuccess: false,
          FailGettingContractAddendums: false,
          error: undefined
        };
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_ADDENDUM_GETBYID_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.addendum.contractId);
      if (CurrentContract) {
        const CurrentAddendum = {
          ...(CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendum.id) || {}),
          ...a.addendum
        } as ContractAddendum;
        CurrentContract.addendums = CurrentContract.addendums
          ? [...CurrentContract.addendums.filter((item: ContractAddendum) => item.id !== a.addendum.id), a.addendum]
          : [a.addendum];
        CurrentContract = {
          ...CurrentContract,
          isGettingContractAddendums: false,
          isGettingContractAddendumsSuccess: true,
          FailGettingContractAddendums: false,
          ErrorGettingContractAddendums: undefined
        };
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_ADDENDUM_GETBYID_FAILURE': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isUpdating: false,
            isUpdatedSuccessfully: false,
            failOnUpdating: true,
            error: a.error
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
        error: a.error
      };
    }
    case 'CONTRACT_ADDENDUM_CREATE_REQUEST': {
      return {
        ...currentState,
        isAddingNewOne: true,
        successAddingNewOne: undefined,
        failOnAddingNewOne: false,
        error: undefined
      };
    }
    case 'CONTRACT_ADDENDUM_CREATE_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.addendum.contractId);
      if (CurrentContract) {
        CurrentContract.addendums = CurrentContract.addendums ? [...CurrentContract.addendums, a.addendum] : [a.addendum];
      }
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: true,
        failOnAddingNewOne: false,
        error: undefined,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_ADDENDUM_CREATE_FAILURE': {
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: false,
        failOnAddingNewOne: true,
        error: a.error
      };
    }
    case 'CONTRACT_ADDENDUM_UPDATE_REQUEST': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.addendum.contractId);
      if (CurrentContract) {
        const found = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendum.id);
        if (found) {
          const updated: ContractAddendum = {
            ...found,
            ...a.addendum,
            isUpdating: true,
            isUpdatedSuccessfully: undefined,
            failOnUpdating: false,
            ErrorUpdating: undefined
          } as ContractAddendum;
          CurrentContract.addendums = CurrentContract.addendums
            ? [...CurrentContract.addendums.filter((item: ContractAddendum) => item.id !== a.addendum.id), updated]
            : [updated];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_ADDENDUM_UPDATE_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let UpdatedAddendums: ContractAddendum[] = [];
        a.addendums.forEach((addendum: ContractAddendum) => {
          let currentaddendum = CurrentContract?.addendums?.find((item: ContractAddendum) => item.id === addendum.id);
          if (currentaddendum) {
            let auxAddendum: ContractAddendum = {
              ...addendum,
              isUpdating: false,
              isUpdatedSuccessfully: true,
              failOnUpdating: false,
              ErrorUpdating: undefined
            } as ContractAddendum;
            auxAddendum.stages = currentaddendum.stages;
            auxAddendum.concepts = currentaddendum.concepts;
            auxAddendum.branches = currentaddendum.branches;
            auxAddendum.cycles = currentaddendum.cycles;
            UpdatedAddendums = [...UpdatedAddendums, auxAddendum];
          } else {
            UpdatedAddendums = [...UpdatedAddendums, addendum];
          }
        });
        CurrentContract = { ...CurrentContract, addendums: UpdatedAddendums };
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_ADDENDUM_UPDATE_FAILURE': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isUpdating: false,
            isUpdatedSuccessfully: false,
            failOnUpdating: true,
            ErrorUpdating: a.error
          } as any;
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_ADDENDUM_DELETE_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        CurrentContract.addendums = (CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId);
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACT_ADDENDUM_CLONE_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        CurrentContract.addendums = [...(CurrentContract.addendums || []), a.addendum];
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_ADD_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractStage.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractStage.contractAddendumId);
        if (CurrentAddendum) {
            CurrentAddendum = { ...CurrentAddendum, stages: [...(CurrentAddendum.stages ?? []), a.contractStage] };
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum!.id), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_UPDATE_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractStage.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractStage.contractAddendumId);
        if (CurrentAddendum) {
          let currentStage = CurrentAddendum.stages?.find((item: ContractStage) => item.id === a.contractStage.id);
          if (currentStage) {
            currentStage = {
              ...currentStage,
              isUpdating: true,
              isUpdatedSuccessfully: undefined,
              failOnUpdating: false,
              errorOnUpdating: undefined
            } as any;
            CurrentAddendum.stages = [...(CurrentAddendum.stages || []).filter((stage: ContractStage) => stage.id !== (currentStage as ContractStage).id), currentStage as ContractStage];
          }
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum!.id), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_UPDATE_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractStage.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractStage.contractAddendumId);
        if (CurrentAddendum) {
          let currentStage = CurrentAddendum.stages?.find((item: ContractStage) => item.id === a.contractStage.id);
          if (currentStage) {
            currentStage = { ...currentStage, ...a.contractStage } as ContractStage;
            currentStage = {
              ...currentStage,
              isUpdating: false,
              isUpdatedSuccessfully: true,
              failOnUpdating: false,
              errorOnUpdating: undefined
            } as any;
            CurrentAddendum.stages = [...(CurrentAddendum.stages || []).filter((stage: ContractStage) => stage.id !== (currentStage as ContractStage).id), currentStage as ContractStage];
          }
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum!.id), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_DELETE_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          CurrentAddendum.stages = (CurrentAddendum.stages || []).filter((item: ContractStage) => item.id !== a.contractStageId);
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    default:
      return currentState;
  }
}
